import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isAdminLoggedIn } from './AuthService';

const PrivateAdminRoute = ({ component: content, ...rest }) => (
      <Route
            render={({ location }) => {
                  if (isAdminLoggedIn()) {
                        return <Route component={content} {...rest} />;
                  }
                  return <Redirect
                        to={{
                              pathname: "/login",
                              state: { from: location }
                        }}
                  />;
            }}
      />
);

export default PrivateAdminRoute;